import React from 'react'

// Create our number formatter.
var formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'

  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export const productHeadings = (grouped) => {
  const headings = getCurrentHeadings(grouped)

  return headings
}

const getCurrentHeadings = (grouped) => {
  return headings(grouped)
}

function checkIconRenderer (params) {
  if (params.value) {
    return <i className='fas fa-check' style={{ color: 'green' }}></i>
  } else {
    return null
  }
}

const headings = (grouped) => {
  return [
    prodCodeHeading(grouped),
    barcodeHeading(grouped),
    {
      headerName: 'Info',
      flex: 1,
      children: [
        {
          headerName: 'Description',
          field: 'description',
          filter: 'agTextColumnFilter',
          minWidth: 250
        },
        {
          headerName: 'Topline Category',
          field: 'toplinecategory',
          filter: 'agSetColumnFilter',
          rowGroup: grouped,
          chartDataType: 'excluded',
          columnGroupShow: 'closed'
        },
        {
          headerName: 'Current Sale Price',
          field: 'currentsaleprice',
          filter: 'agNumberColumnFilter',
          chartDataType: 'series',
          columnGroupShow: 'closed',
          valueFormatter: currencyFormatter
        },
        {
          headerName: 'Tax Rate',
          field: 'taxrate',
          filter: 'agNumberColumnFilter',
          chartDataType: 'excluded',
          columnGroupShow: 'closed',
          valueFormatter: percentFormatter
        }
        // {
        //   headerName: 'Issue Number',
        //   field: 'issuenumber',
        //   filter: 'agTextColumnFilter',
        //   chartDataType: 'excluded',
        //   columnGroupShow: 'closed',
        //   disableColumn: 1,
        //   hide: true
        // }
      ]
    },
    {
      headerName: 'Wholesaler',
      flex: 1,
      children: [
        {
          headerName: 'Wholesaler',
          field: 'wholesaler',
          chartDataType: 'excluded',
          disableColumn: 0,
          hide: true,
          columnGroupShow: 'open'
        },
        {
          headerName: 'Pack Cost',
          field: 'packcost',
          filter: 'agNumberColumnFilter',
          chartDataType: 'series',
          columnGroupShow: 'open',
          valueFormatter: currencyFormatter
        },
        {
          headerName: 'Pack Size',
          field: 'packsize',
          filter: 'agNumberColumnFilter',
          chartDataType: 'series',
          columnGroupShow: 'open'
        },
        {
          headerName: 'Unit cost price',
          field: 'unitcostprice',
          filter: 'agNumberColumnFilter',
          chartDataType: 'series',
          columnGroupShow: 'open',
          valueFormatter: currencyFormatter
        }
      ]
    },
    {
      headerName: 'Sales',
      flex: 1,
      disableColumn: 0,
      children: [
        {
          headerName: 'Date Last Sold',
          field: 'datelastsold',
          filter: 'agDateColumnFilter',
          hide: false,
          columnGroupShow: 'open',
          valueFormatter: dateFormatter
        }
        //     {
        //       headerName: 'Qty & Value Sold Last Week',
        //       field: 'qtyvaluesoldlastweek',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     },
        //     {
        //       headerName: 'Qty & Value Sold Last Month',
        //       field: 'qtyvaluesoldlastmonth',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     },
        //     {
        //       headerName: 'Av. Qty Sold Per Week',
        //       field: 'avqtysoldperweek',
        //       chartDataType: 'series',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     }
      ]
    },
    {
      headerName: 'History',
      flex: 1,
      children: [
        {
          headerName: 'Promotion',
          field: 'promotion',
          filter: 'agSetColumnFilter',
          columnGroupShow: 'open',
          cellRenderer: checkIconRenderer
        }
        // {
        //   headerName: 'Last Price Change Date',
        //   field: 'lastpricechangedate',
        //   hide: true,
        //   disableColumn: 1,
        //   columnGroupShow: 'open'
        // },
        // {
        //   headerName: 'Last Price Change Value',
        //   field: 'lastpricechangevalue',
        //   chartDataType: 'series',
        //   hide: true,
        //   disableColumn: 1,
        //   columnGroupShow: 'open'
        // },
        // {
        //   headerName: 'Days at Current Price',
        //   field: 'daysatcurrentprice',
        //   chartDataType: 'series',
        //   hide: true,
        //   disableColumn: 1,
        //   columnGroupShow: 'open'
        // }
      ]
    },
    {
      headerName: 'Stock',
      flex: 1,
      disableColumn: 0,
      children: [
        {
          headerName: 'Qty In Stock',
          field: 'qtyinstock',
          chartDataType: 'series',
          filter: 'agNumberColumnFilter',
          hide: false,
          columnGroupShow: 'open'
        }
        //     {
        //       headerName: 'Date Stock Adjusted',
        //       field: 'datestockadjusted',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     },
        //     {
        //       headerName: 'Last Adjusted Reason',
        //       field: 'lastadjustedreason',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     },
        //     {
        //       headerName: 'Last Goods In',
        //       field: 'lastgoodsin',
        //       hide: true,
        //       columnGroupShow: 'open'
        //     }
      ]
    }
  ]
}

const prodCodeHeading = (hide) => {
  const heading = {
    headerName: 'Prod Code',
    field: 'prodcode',
    minWidth: '125',
    type: 'numberColumn',
    filter: 'agTextColumnFilter',
    chartDataType: 'category',
    pinned: 'left',
    columnGroupShow: hide === 1 ? 'closed' : 'open'
  }

  return heading
}

const barcodeHeading = (hide) => {
  const heading = {
    headerName: 'Barcode',
    field: 'barcode',
    minWidth: '125',
    type: 'numberColumn',
    filter: 'agTextColumnFilter',
    chartDataType: 'category',
    pinned: 'left',
    columnGroupShow: hide === 1 ? 'closed' : 'open'
  }

  return heading
}

function currencyFormatter (params) {
  if (params.value !== '-') {
    params.value = formatter.format(params.value)
    return params.value
  }
}

function percentFormatter (params) {
  if (params.value !== '-') {
    params.value = params.value.toFixed(2) + ' %'
    return params.value
  }
}

function dateFormatter (params) {
  let result = ''

  if (params.value.getTime() > 0) {
    result = params.value.toLocaleDateString('en-GB', { // you can use undefined as first argument
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  }

  return result
}
